import * as yup from "yup";

export const EndUserSchema = yup.object().shape({
  first_name: yup.string().required().label("First Name"),
  last_name: yup.string().required().label("Last Name"),
  email: yup.string().email().required().label("Email"),
});
